import React, { useState } from 'react';
import axios from '../../axiosConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/NewAuth.css';

const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token'); // Pobranie tokena z URL

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        if (password !== confirmPassword) {
            setError('Hasła nie są zgodne.');
            setLoading(false);
            return;
        }

        try {
            await axios.post('/api/v1/auth/reset-password', { token, newPassword: password });
            setMessage('Hasło zostało zmienione pomyślnie.');
            setTimeout(() => navigate('/'), 2000); // Automatyczne przekierowanie do logowania
        } catch (err) {
            setError('Nie udało się zresetować hasła. Spróbuj ponownie.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h1>Ustaw nowe hasło</h1>
                <p>Wpisz nowe hasło dwa razy, aby je zaktualizować.</p>
                <form className="auth-form" onSubmit={handleSubmit}>
                    <input
                        type="password"
                        name="password"
                        placeholder="Nowe hasło"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Powtórz nowe hasło"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    {message && <p className="success-message">{message}</p>}
                    {error && <p className="error">{error}</p>}
                    <button type="submit" disabled={loading}>
                        {loading ? 'Zapisywanie...' : 'Zmień hasło'}
                    </button>
                    <button type="button" className="back-btn" onClick={() => navigate('/')}>
                        Powrót do logowania
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;